import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../app/utils/baseQueryWithReauth';

export const botsApi = createApi({
    reducerPath: 'botsApi',
    baseQuery: baseQueryWithReauth(process.env.REACT_APP_BOTS_SERVICE_URL),
    endpoints: (builder) => ({
        getMyBots: builder.query({
            query: () => '/v1/my',
        }),
    }),
});

export const { useGetMyBotsQuery } = botsApi;
